import Vue from 'vue'
import Vuex from 'vuex'

import Core from '../apps/core/store'
import Auth from '../apps/auth/store'
import Plant from '../apps/plant/store'
import Ticket from '../apps/ticket/store'
import Stakeholder from '../apps/stakeholder/store'
import User from '../apps/user/store'
import Url from '../apps/url/store'
import Control from '../apps/control/store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    core: Core,
    auth: Auth,
    plant: Plant,
    ticket: Ticket,
    stakeholder: Stakeholder,
    user: User,
    url: Url,
    control: Control,
  },
})
